import { render, staticRenderFns } from "./GlobalTab.vue?vue&type=template&id=20209a6a&scoped=true&"
import script from "./GlobalTab.vue?vue&type=script&lang=js&"
export * from "./GlobalTab.vue?vue&type=script&lang=js&"
import style0 from "./GlobalTab.vue?vue&type=style&index=0&id=20209a6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20209a6a",
  null
  
)

export default component.exports